import React, {Component} from 'react';
import axios from 'axios';
import { FaCreditCard } from "react-icons/fa";
import { Card, CardBody, Table } from 'reactstrap';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import HistoryTransactionComponent from "../../../components/Customer/payments/HistoryTransactionComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";

class HistoryTransactionPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listPayment: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            typeOrder: '',
            qtt: 30
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListPayment();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListPayment = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&typeOrder=" + this.state.typeOrder;

        axios.get( process.env.REACT_APP_API_URL + '/api/payment/getListHistoryTransaction' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listPayment: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                // console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    changeQtt = (event) => {
        this.setState({
            qtt: event.target.value
        })
        this.getListPayment();
    }

    changeTypeOrder = (event) => {
        // console.log(event.target.value)
        this.search({
            typeOrder: event.target.value
        })
        this.getListPayment();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?userId=" + this.state.userId + "&typeOrder=" + this.state.typeOrder + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/payment/getListHistoryTransaction' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listPayment: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                // console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    screentListOrder = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listPayment.length ) {
                return (
                    this.state.listPayment.map( (payment, key) => {
                        return (
                            <HistoryTransactionComponent
                                key={key}
                                payment={payment}
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có giao dịch trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Lịch sử giao dịch"} page={"Giao dịch"}  icon={<FaCreditCard className="breadcrumb-icon"/>}/>
                            <Card>
                                <CardBody>
                                    <div className="col-12">
                                    </div>
                                    <div className="row">
                                        <div className="col col-md-12 table-responsive">
                                            <Table className="table table-sm table-bordered table-hover rounded text-center">
                                                <thead>
                                                    <tr>
                                                        <th>Mã giao dịch</th>
                                                        <th>Loại</th>
                                                        <th>Chi tiết</th>
                                                        <th>Số tiền</th>
                                                        <th>Thời gian</th>
                                                        <th>Số dư trước</th>
                                                        <th>Số dư sau</th>
                                                        <th>Trạng thái</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { this.screentListOrder() }
                                                </tbody>
                                            </Table>
                                            { this.paginate() }
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminHistoryTran' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HistoryTransactionPage);